define('views/content/cd_role',['require','views/base/item_page_view','text!templates/content/cd_role.html'],function(require){

    var BaseItemPageView = require('views/base/item_page_view');

    var temp = require("text!templates/content/cd_role.html");
    return BaseItemPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'cd-role-page page',
        basePath: 'cd-roles',
        titleKey: 'add_personal_role',
        afterInitialize: function () {
            this.model.set('country_distributor',App.user.get('country_distributor'));
        },
        ui: function() {
            return {
                select2Input: '[data-init-plugin="select2"]',
                mainForm : '#main-form',
                submitButton: '#submit-button',

            };
        },

        events: {
            'change form input': 'formChanged',
            'change form textarea': 'formChanged',
            'change form select': 'formChanged',

            'click @ui.submitButton': 'submitButtonClicked',

            'change @ui.countrySelect': 'countryChanged'
        },
        
        setupFormValidation: function () {
            this.ui.mainForm.validate({
                rules: {
                    'role_name': "required",

                },
                messages: {
                    'role_name': App.polyglot.t('personal_role_name_required'),

                },

                onfocusout: false,
                onkeyup: false,
                onclick: false,

                showErrors: function (errorMap, errorList) {
                    for (var i=0; i<errorList.length; i++) {
                        App.utils.showMessage('error', errorList[i].message);
                    }
                }
            });
        },
    });
});
